import Vue from 'vue';
import {indexOf, map} from 'lodash';
import {createPhase, loadPhases, removePhase, updatePhase} from '../../modules/api/phase.api';

export const getters = {
    phases:                (state) => state.phases,
    phasesForAutocomplete: (state) => state.phases.map(({ id, title }) => {
        return { name: title, id };
    }),
    loadPhaseById:         (state, getters) => (phaseId) => {
        return new Promise((resolve) => resolve(getters.phases.find((phase) => phase.id === phaseId) || null));
    },
}

export const actions = {
    async createPhase({ commit, getters }, data) {
        const projectId = getters.projectId;
        return createPhase({ ...data, projectId }).then((data) => commit('ADD_PHASE', data))
    },
    async updatePhase({ commit }, data) {
        return updatePhase(data).then((data) => commit('UPDATE_PHASE', data))
    },
    async removePhase({ commit }, phaseId) {
        return removePhase(phaseId).then(() => commit('REMOVE_PHASE', phaseId))
    },
    async loadPhases({ commit, getters }) {
        return loadPhases(getters.projectId).then((data) => commit('SET_PHASES', data));
    },
}

export const mutations = {
    SET_PHASES:   (state, phasesData) => state.phases = phasesData,
    ADD_PHASE:    (state, phaseData) => state.phases.push(phaseData),
    UPDATE_PHASE: (state, phaseData) => {
        const index = indexOf(map(state.phases, (object) => object.id), phaseData.id);
        Vue.set(state.phases, index, phaseData);
    },
    REMOVE_PHASE: (state, phaseId) => {
        const index = indexOf(map(state.phases, (object) => object.id), phaseId);
        if (index !== -1) {
            state.phases.splice(index, 1);
        }
    },
}
